import React from 'react';
import { TextField } from '@material-ui/core';

const AddAdmUser = ({ formData, setFormData, userWhoCreated }) => {
  return (
    <>
      <TextField
        label="E-mail"
        fullWidth
        value={formData?.email || ''}
        onChange={(e) => setFormData({ ...formData, email: e.target.value, userWhoCreated })}
        margin="normal"
        variant="outlined"
      />
    </>
  );
};

export default AddAdmUser;
